import { render, staticRenderFns } from "./ProfileSettings.vue?vue&type=template&id=7c489b50"
import script from "@/scripts/auth/profileSettings.js?vue&type=script&lang=js&external"
export * from "@/scripts/auth/profileSettings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports